window.onload = function() {
  streamRequest();
};

function streamRequest() {
  const id = getTzMappedId();
  const xhr = new XMLHttpRequest();
  const mainContainer = document.querySelector('.iheart_stream_container');

  if (!mainContainer) {
    return;
  }
  xhr.open(
    'GET',
    `${fetchStreamAjax.ajax_url}?action=stream_fetch&ID=` + `${id}`,
    true
  );
  xhr.responseType = 'json';
  xhr.onreadystatechange = function() {
    if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
      const streamList = document.querySelector('.stream_list');
      const loading = document.querySelector('#stream-loading');
      this.response.data.forEach(item => {
        const convertedStartTime = getTime(item.start);
        const formattedDuration = formatTime(item.duration);
        const li = document.createElement('li');
        li.innerHTML = `
        <span class="stream_start">${convertedStartTime}</span>
        <div class="stream_info">
             ${
               item.image
                 ? `<a class="artist_image" href="https://www.iheart.com/artist/${item.artistID}" target="_blank">
              <img src="${item.image}" width="50px" height="50px" alt="${item.artist}"/>
            </a>`
                 : `<a class="artist_image" href="https://www.iheart.com/live/cada-6179/" target="_blank">
              <img src="/wp-content/themes/arn/assets/img/cada_square.png" width="50px" height="50px" alt="CADA"/>
            </a>`
             }
            <a class="song_details" href="https://www.iheart.com/artist/${
              item.artistID
            }" target="_blank">
              <p class="song_name">${item.title}</p>
              <span class="artist_name">${item.artist}</span>
            </a>
        </div>
        <p class="song_duration">${formattedDuration}</p>
      `;
        loading.classList.remove('visible');
        streamList.appendChild(li);
      });
    } else if (this.readyState === XMLHttpRequest.DONE) {
      const streamList = document.querySelector('.stream_list');
      const loading = document.querySelector('#stream-loading');
      console.log(this.response, this.status);
      const div = document.createElement('div');
      div.innerHTML = `
        <p class="stream_start">No streams found.</p>
        `;
      loading.classList.remove('visible');
      streamList.appendChild(div);
    }
  };
  xhr.timeout = 5000;
  xhr.ontimeout = function() {
    console.log('Request timed out');
  };
  xhr.send();
}

function getTzMappedId() {
  let tzMappedId;

  const streamIds = window.iHeart_stream_data;

  // Resolving the time zone of the users.
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  if (tz && streamIds) {
    // check weather the user is from Australia or not
    const checkCountry = getUserCountery(tz);

    if (!checkCountry) {
      tzMappedId = streamIds.Sydney;
    } else {
      // getting user city
      const userCity = tz.replace('Australia/', '');

      // getting user time
      const userTime = getTimeForTimeZone(userCity);

      // initally setting all the urls to sydney
      tzMappedId = streamIds.Syndey;

      for (const city in streamIds) {
        // getting the time for the current city in loop
        const cityTime = getTimeForTimeZone(city);

        if (userCity === city && userTime === cityTime) {
          // getting the url for the city
          const id = streamIds[city];

          tzMappedId = id;
        }
      }
    }
  }
  return tzMappedId;
}

// Get the time for timezone specified
function getTimeForTimeZone(timeZone) {
  const time = new Date();
  return time.toLocaleString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: `Australia/${timeZone}`,
  });
}

// Check user is from Australia or not
function getUserCountery(timezone) {
  const lookupCountry = 'Australia';
  return timezone.includes(lookupCountry);
}

function getTime(timestamp) {
  const date = new Date(timestamp * 1000);
  let hours = date.getHours();
  let minutes = date.getMinutes();
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours %= 12;
  hours = hours || 12; // the hour '0' should be '12'
  const formattedTime = `${hours}:${minutes} ${ampm}`;

  return formattedTime;
}

function formatTime(seconds) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')} sec`;
}

export {
  streamRequest
}

window.songList = streamRequest;
